import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import MaterialIconButton from '@material-ui/core/IconButton';
import { ExtendedColorTypes, IconButtonSize } from '../../types';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        button: function (_a) {
            var _b = _a.style, style = _b === void 0 ? {} : _b;
            return ({
                padding: style.padding || 3,
                fontSize: style.fontSize || 'inherited',
                '&:hover, &.Mui-focusVisible': {
                    backgroundColor: '#dedede',
                },
            });
        },
        icon: {
            fill: function (_a) {
                var disabled = _a.disabled, color = _a.color;
                if (disabled) {
                    return theme.commonSettings.disabledColor || '#C0C0C0';
                }
                if (color === ExtendedColorTypes.Secondary) {
                    return theme.palette.secondary.main;
                }
                if (color === ExtendedColorTypes.Error) {
                    return theme.palette.warning.main;
                }
                return theme.palette.primary.main;
            },
        },
        borderedButton: {
            border: "1px solid ".concat(theme.commonSettings.borderColor),
            borderRadius: 4,
        },
    });
});
/**
 * @deprecated
 * Use `IconButton` to render a button only with an icon
 */
function IconButton(props) {
    var icon = props.icon, _a = props.size, size = _a === void 0 ? IconButtonSize.small : _a, onClick = props.onClick, _b = props.disabled, disabled = _b === void 0 ? false : _b, border = props.border, _c = props.elementId, elementId = _c === void 0 ? '' : _c;
    var classes = useStyles(props);
    var TheIcon = icon;
    return (React.createElement(MaterialIconButton, { className: "".concat(classes.button, " ").concat(border ? classes.borderedButton : null), onClick: onClick || undefined, size: size, disabled: disabled, disableRipple: true, "data-testid": elementId },
        React.createElement(TheIcon, { className: classes.icon })));
}
export default IconButton;
//# sourceMappingURL=IconButton.js.map